import State from '../interfaces/states/State';

import MapFieldList from '../interfaces/MapFieldList';
import Coordinates from '../interfaces/Coordinates';

import { createSelector } from 'reselect';

export const isError$ = (state: State): boolean => state.mapFieldList.isError;

export const isLoading$ = (state: State): boolean => state.mapFieldList.isLoading;

export const mapFieldListById$ = (state: State): Record<number, MapFieldList> => state.mapFieldList.mapFieldList;

export const mapFieldListOrder$ = (state: State): number[] => state.mapFieldList.mapFieldListOrder;

export const currentId$ = (state: State): number => state.mapFieldList.currentId;

export const mapCoordinates$ = createSelector(
  currentId$,
  mapFieldListById$,
  (currentId, mapFieldListById): void => {
    if (currentId !== null) {
      // tslint:disable-next-line:no-unused-expression
      mapFieldListById[currentId]['geometry']['coordinates'];
    }
  }
);

export const mapCenter$ = (state: State): Coordinates => {
  if (currentId$(state) !== null) {
    return mapFieldListById$(state)[currentId$(state)].properties.center.coordinates;
  } else {
    return [];
  }
};
